module.exports = __webpack_public_path__ + "img/BU.42bb720f.png";